import React from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import AppContainer from './containers/app';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { Provider } from 'react-redux'
import thunk from 'redux-thunk';
import { unregister } from './registerServiceWorker';

import * as reducers from './stores/reducers';

const store = createStore(combineReducers(reducers), applyMiddleware(thunk));

import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

Bugsnag.start({
  apiKey: '1fe490bc05d62c2bf1c2a281c99036d8',
  plugins: [new BugsnagPluginReact()]
});

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

ReactDOM.render((
  <ErrorBoundary>
    <Provider store={ store }>
      <HelmetProvider>
        <AppContainer />
      </HelmetProvider>
    </Provider>
  </ErrorBoundary>
), document.getElementById('root'));
unregister();



// WEBPACK FOOTER //
// ./src/index.js